// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as React from "react";
import * as Utils$OrcaPaymentPage from "../Utilities/Utils.bs.js";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";

function InstallmentPlanDetails(props) {
  var currency = props.currency;
  var plan = props.plan;
  var match = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.configAtom);
  var localeString = match.localeString;
  var themeObj = match.themeObj;
  var interestLabel = plan.interest_rate === 0.0 ? localeString.installmentInterestFree : localeString.installmentWithInterest;
  var amountPerInstallment = Utils$OrcaPaymentPage.formatAmountWithTwoDecimals(plan.amount_details.amount_per_installment);
  var totalAmount = Utils$OrcaPaymentPage.formatAmountWithTwoDecimals(plan.amount_details.total_amount);
  var mainLabel = plan.number_of_installments.toString() + " X " + currency + " " + amountPerInstallment;
  var totalLabel = localeString.installmentTotal;
  return React.createElement("div", {
              className: "flex flex-col flex-1 min-w-0"
            }, React.createElement("div", {
                  className: "flex items-center justify-between w-full"
                }, React.createElement("span", {
                      style: {
                        color: themeObj.colorText,
                        fontSize: themeObj.fontSizeLg
                      }
                    }, mainLabel), React.createElement("span", {
                      style: {
                        color: themeObj.colorTextSecondary,
                        fontSize: themeObj.fontSizeSm
                      }
                    }, totalLabel)), React.createElement("div", {
                  className: "flex items-center justify-between w-full mt-px"
                }, React.createElement("span", {
                      style: {
                        color: themeObj.colorTextSecondary,
                        fontSize: themeObj.fontSizeSm
                      }
                    }, interestLabel), React.createElement("span", {
                      style: {
                        color: themeObj.colorText,
                        fontSize: themeObj.fontSizeLg
                      }
                    }, currency + " " + totalAmount)));
}

var make = InstallmentPlanDetails;

export {
  make ,
}
/* jotai Not a pure module */
